import { Fragment } from "react";
import AdUnit, { AdUnitTypeEnum } from "./AdUnit";
import useWindowDimensions from "../../hooks/useWindowDimension";
import { AdUnitsKeys } from "./config/units";

interface IProps {
  position: number;
  mobileAds: AdUnitsKeys[];
  desktopAds: AdUnitsKeys[];
}

const AD_POSITION_FACTOR = 4;

export const ScrollAdDispatcher = (props: IProps) => {
  const { position, mobileAds, desktopAds } = props;

  const isDesktop = useWindowDimensions();

  const canShow = position % AD_POSITION_FACTOR === 0;
  const index = (position / AD_POSITION_FACTOR) - 1;
  const currentAds = isDesktop ? desktopAds : mobileAds;
  const type = isDesktop ? AdUnitTypeEnum.DESKTOP : AdUnitTypeEnum.MOBILE;

  return (
    <Fragment>
      {
        canShow && currentAds[index] && (
          <AdUnit name={currentAds[index]} type={type}/>
        )
      }
    </Fragment>
  );
};
